import { AxiosError } from "axios";
import * as R from "../../../requests/x2y/requestCreators";
import { X2yResponse } from "../../../requests/x2y/types";
import flowioast from "../../../utils/flowioast";
import { FlowioThunkCreator } from "../../types";
import * as AC from "../actionCreators";
import * as S from "../selectors";
import { X2yController } from "../types";

type MakeThunkCreatorParams = {
  controller: X2yController;
};

// Thunk creator types
type ThunkCreatorParams = { xId: number; payload: X2yResponse };

export type UpdateThunkCreator = FlowioThunkCreator<ThunkCreatorParams>;
export type MakeUpdateThunkCreator = (
  p: MakeThunkCreatorParams
) => UpdateThunkCreator;

// ==== FACTORY ====
const createUpdateThunk: MakeUpdateThunkCreator = ({ controller }) => {
  const getIsSubmitting = S.creteGetIsSubmitting(controller);
  const request = R[controller].update;

  return ({ xId, payload }) =>
    (dispatch, getState) =>
      Promise.resolve().then(async () => {
        const isSubmitting = getIsSubmitting(getState(), [xId]);
        if (isSubmitting) return;
        const reqPayload = { controller, xId, payload };
        dispatch(AC.updateX2yRequest(reqPayload));

        try {
          const response = await request(xId, payload);
          const recPayload = { controller, xId, ...response.data };
          dispatch(AC.updateX2yReceive(recPayload));
          flowioast.success.fromIntlBase("settings.save.singular");
        } catch (error) {
          const errPayload = {
            controller,
            xId,
            error: (error as AxiosError).response || error,
          };
          dispatch(AC.updateX2yError(errPayload));
          flowioast.error.fromIntlBase("settings.save.singular", error);
        }
      });
};

export default createUpdateThunk;
